import { makeStyles } from "@material-ui/core/styles";
import { grey300, secondary } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: "50vw",
    maxWidth: "60vw",
    padding: `0 ${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(
      4
    )}px`,
  },
  buttonSeparation: {
    marginRight: theme.spacing(1),
  },
  datepicker: {
    border: `solid 1px ${grey300}`,
    height: theme.spacing(4),
    width: 200,
    cursor: "pointer",

    "& .MuiGrid-root": {
      height: "100%",
      padding: `0 ${theme.spacing(1)}px`,

      "& svg": {
        color: secondary,
      },
    },
  },
  currencyLabel: {
    marginLeft: theme.spacing(1),
  },
  tooltipRow: {
    padding: `${theme.spacing(1)}px 0`,
  },
  tooltipIcon: {
    marginRight: theme.spacing(1),
  },
  inputLabel: {
    paddingTop: theme.spacing(3),
  },
}));

export default useStyles;
